import { IconButton } from "@mui/material";
import { IconEye } from "@tabler/icons";

const DisabledViewIcon = () => (

        <IconButton size="small" disabled>
          <IconEye size="1.1rem" />
        </IconButton>
  );

  export default DisabledViewIcon;
  